<template>
    <el-form class="send-form" ref='sendForm' :model='sendForm' :rules='rules'>
        <div class="send-form-title">
            找回密码
            <router-link to="/login">返回登录界面</router-link>
        </div>
        <el-form-item prop="email">
            <el-input v-model="sendForm.email" placeholder="请输入正确的邮箱号">
                <img slot="prefix" style="padding: 13px 8px;" src="./images/email.png">
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button 
                class="submitBtn" 
                type="primary"
                @click="submitForm('sendForm')">发送邮件</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import {apiJson, http} from '@/utils/http'
import axios from 'axios'
import {Message} from 'element-ui'
export default {
    data () {
        return {
            sendBtnStatus: false,
            sendForm: {
                email: ''
            },
            rules: {
                email: [
                    {required: true, message: '请输入邮箱号', trigger: 'blur'},
                    {
                        pattern: /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,5}$/, 
                        message: '请输入正确的邮箱号', 
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    created () {

    },
    methods: {
        submitForm(sendForm) {
            this.$refs[sendForm].validate(valid => {
                if (valid) {
                    http(apiJson.findpwbyemail,this.sendForm).then(res => {
                        if(res.code == 0) {
                            Message.success(res.data)
                        }
                    })
                } else {
                    Message.warning('请填写邮箱号')
                    return false;
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    .send-form { 
        &-title {
            margin-top: 80px;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            padding-bottom: 30px;
            span {
                font-weight: normal;
                line-height: 25px;
                font-size: 12px;
                color: #000000;
                float: right;
                a {
                    color: #409EFF;
                }
            }
        }
        .submitBtn {
            width: 100%;
            color: #ffffff;
            font-size: 16px;
        }
        a {
            font-size: 12px;
            color: #409EFF;
            float: right;
            font-weight: normal;
        }
    }
</style>





// WEBPACK FOOTER //
// src/pages/Login/findPwBe.vue